<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
              <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="12">
              <h3>Create Grade Category</h3>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Campaign:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <CampaignAutocomplete :key="companySearchComponentKey" class="searchbox" :list="searchCampaign"
                :searchOn="'campaign'" @event-name="selectCampaign"></CampaignAutocomplete>
            </div>
            <span class="text-danger text-sm mt-3" v-show="campaign_required">{{ campaign_required }}
            </span>

          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="name" v-model="grade_category.name" v-validate="'required'"
                data-vv-as="Name" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('name')">{{ errors.first("name") }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="description" v-model="grade_category.description" v-validate="'required'"
                data-vv-as="Fields Description" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('description')">{{
                errors.first("description")
            }}</span>
          </div>
          <div class="vx-row mb-6" v-if="campaign_grade_lists.length != 0">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Grades:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">


              <template>


                <vs-row vs-w="12" class="mt-5">
                  <vs-col class="mb-5" v-for="campaign_grade_list in campaign_grade_lists" vs-lg="2" vs-sm="6"
                    vs-xs="12">
                    <span>{{ campaign_grade_list.grade }}</span>
                    <input class="ml-1" type="checkbox" v-model="grade_category.grades"
                      :value="campaign_grade_list.grade" />

                  </vs-col>
                </vs-row>




              </template>

            </div>
          </div>

          <div class="vx-row mb-6" v-if="!campaign_opportunity_already_created">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Is Opportunity:</span>
            </div>
            <input class="ml-4" type="checkbox" v-model="grade_category.is_opportunity" />
            <div>

            </div>
          </div>

          <div class="vx-row mb-6" v-if="!grades_can_be_changes_by_sd_already_created">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Grades can be changed by Sales Developer:</span>
            </div>
            <input class="ml-4" type="checkbox" v-model="grade_category.grades_can_be_changes_by_sd" />
            <div>

            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">

            </div>
            <div class="ml-4">
              <vs-button class="mb-2" @click.prevent="submitForm">Submit</vs-button>

            </div>
            <div>

            </div>
          </div>



          <DataGrid :context="'CampaignGradeCategory'" v-if="campaign_grade_lists.length != 0" ref="CampaignGradeCategory" :sideBar=sideBar :columnDefs="columnDefs" :rowData="records" :dataSource="dataSource">
          </DataGrid>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import vSelect from "vue-select";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
      campaign_opportunity_already_created:false,
      grades_can_be_changes_by_sd_already_created:false,
      selected_campaign: null,
      selected_campaign_id: null,
      campaign_required: null,
      companySearchComponentKey: 0,
      please_choose_grades: null,
      chooseExistingList: false,
      columnDefs: [
        // {
        //   headerName: "Actions",
        //   field: "transactions",
        //   cellRendererFramework: "CellRendererActions",
        //   suppressHeaderMenuButton: true,
        //   pinned: true,
        //   width: 120
        // },
        {
          headerName: "Campaign",
          field: "campaign_name",
          width: 400,
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            suppressAndOrCondition: false
          },
        },
        {
          headerName: "Name",
          field: "name",
          width: 400,
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            suppressAndOrCondition: false
          },
        },
        {
          headerName: "Description",
          field: "description",
          width: 400,

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            suppressAndOrCondition: false
          }
        },
        {
          headerName: "Grades",
          width: 400,
          field: "grades",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            suppressAndOrCondition: false
          }
        },
        {
          headerName: "Is Opportunity",
          field: "is_opportunity",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            suppressAndOrCondition: false
          }
        },
        {
          headerName: "Grades Can Be Changed By SD",
          field: "grades_can_be_changes_by_sd",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            suppressAndOrCondition: false
          }
        }
      ],
      dataSource: {},
      records: [],
      selected: [],
      abilities: null,
      campaign_grade_lists: [],
      grade_category: {
        name: null,
        description: null,
        grades: [],
        is_opportunity: false,
        campaign_id: null,
        user_id: null,
        grades_can_be_changes_by_sd:false
      },
    };
  },
  components: {
    "v-select": vSelect,
    DataGrid,
    CampaignAutocomplete,
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

  },
  mounted() {
  },
  watch: {
  },
  methods: {
    getCampaignGrades(selected_campaign) {
      this.$store
        .dispatch(
          "campaignsManagement/getCampaignGrades",
          selected_campaign
        )
        .then(res => {
          let result = res.data;
          if (result) {
            this.campaign_grade_lists = result;
            this.campaign_grade_lists.sort((a, b) => parseInt(a.grade) > parseInt(b.grade) ? 1 : -1);
          }
          console.log(result)
        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    selectCampaign() {
      this.please_choose_campaign = null;
      this.selected_campaign = moduleCampaignManagement.state.campaign.datas;
      this.selected_campaign_id = this.selected_campaign[0].id

      // alert(this.selected_campaign_id)
      this.grade_category.campaign_id = this.selected_campaign_id
      this.getCampaignGrades(this.selected_campaign_id)
      this.$refs.CampaignGradeCategory.gridApi.refreshServerSide({purge : true});
      this.getDataSource()
    },
    searchCampaign(inputValue) {
      this.please_choose_client = null;

      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          params.request.campaign_id = self.selected_campaign_id
          self.$store
            .dispatch(
              "campaignsManagement/getAllCampaignGradeCategories",
              params.request
            )
            .then(function (response) {
              let response_data = response.rows;

              response_data.forEach(element => {
                if(element.is_opportunity == true){
                  self.campaign_opportunity_already_created = true
                }

                if(element.grades_can_be_changes_by_sd == true){
                  self.grades_can_be_changes_by_sd_already_created = true
                }

                if(element.grades){
                  let element_grades = JSON.parse(element.grades)
                  element_grades = element_grades.sort((a, b) => parseInt(a) > parseInt(b) ? 1 : -1);
                  element.grades = element_grades
                }
                
              });
              if (response_data.length != 0) {
                self.$refs.CampaignGradeCategory.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.CampaignGradeCategory.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function () {
      this.$router.go(-1);
    },
    submitForm() {
      let self = this


      self.$validator.validateAll().then(result => {
        if (result) {
          self.addGradeCategory();
        }
      });
    },
    addGradeCategory() {

      if (this.selected_campaign == null) {
        this.campaign_required = "Campaign field is required";
        return false;
      }
      this.grade_category.user_id = this.user_id

      this.$store.dispatch("campaignsManagement/addGradeCategory", this.grade_category)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Grade Category",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Grade Category",
              text: res.data.message
            });
            this.$router.go(0);
          }
        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
